import axios from "axios";
import { autoGetXAppId, GET_FOTOR_BASE_URL, isInClipFlyAppBrower } from "@Common";

// 提取 baseURL 逻辑到模块级别
function getBaseURL() {
    // 添加客户端检查，避免服务端渲染时的 window 未定义错误
    if (process.client && isInClipFlyAppBrower()) {
        return process.env.CLIPFLY_BASE_URL || '';
    } else {
        return GET_FOTOR_BASE_URL() || '';
    }
}

// 创建 axios 实例，使用动态 baseURL
const service = axios.create({
    baseURL: getBaseURL()
});

/**
 * 注销 Fotor 账号
 * @param token token
 * @returns
 */
export function cancelFotorAccount(token: string) {
    return service({
        url: "/api/user/cancel-account",
        method: "get",
        headers: {
            "x-app-id": autoGetXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 获取 Fotor 账号注销状态
 * @param token token
 * @returns
 */
export function getFotorCancelStatus(token: string) {
    return service({
        url: "/api/user/cancellation",
        method: "get",
        headers: {
            "x-app-id": autoGetXAppId(),
            Authorization: 'bearer ' + token
        },
        withCredentials: true,
    });
}

/**
 * 撤销 Fotor 账号注销申请
 * @param token token
 * @returns
 */
export function withdrawalDeleteFotorAccount(token: string) {
    return service({
        url: "/api/user/undo-cancel",
        method: "delete",
        headers: {
            "x-app-id": autoGetXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}